/**
 * Adds thumbnail strip to the standard PDP PhotoSwipe lightbox.
 *
 * Root cause of prior failures:
 *   pswpModule is `() => import("photoswipe")` — an async dynamic import.
 *   So lb.pswp is NULL immediately after origOpenLightBox returns.
 *   We must attach listeners on lb (PhotoSwipeLightbox) BEFORE calling
 *   the original, then wait for the "openingAnimationEnd" event which fires
 *   only after lb.pswp is fully initialised and the opening animation ends.
 */
(function () {
  'use strict';

  customElements.whenDefined('hdt-product-media').then(() => {
    const ProductMedia = customElements.get('hdt-product-media');
    if (!ProductMedia) return;

    const origOpenLightBox = ProductMedia.prototype.openLightBox;

    ProductMedia.prototype.openLightBox = function (index) {
      const lb = this.lightBox; // creates + inits lightbox on first access
      const productMediaEl = this;

      if (lb && !lb._pdpThumbsSetup) {
        lb._pdpThumbsSetup = true;

        // fires AFTER async module load + opening animation — lb.pswp is set
        lb.on('openingAnimationEnd', () => {
          if (!lb.pswp) return;

          const pswpEl = lb.pswp.element; // the .pswp DOM node
          if (!pswpEl) return;

          // Re-query images at open time so hidden/variant images are correct
          const imgs = Array.from(
            productMediaEl.querySelectorAll(
              '.hdt-product-media__main [data-media-type="image"]:not([hidden]) img[hdt-el]'
            )
          );
          if (imgs.length < 2) return;

          injectThumbnailBar(pswpEl, lb.pswp, imgs);
        });

        lb.on('close', () => {
          const bar = document.querySelector('.pdp-pswp-thumbnails');
          if (bar) bar.remove();
          if (typeof window.pushUiEvent === 'function') {
            window.pushUiEvent('image_gallery_closed');
          }
        });
      }

      if (typeof window.pushUiEvent === 'function') {
        window.pushUiEvent('image_gallery_open', { image_index: index || 0 });
      }
      origOpenLightBox.call(this, index);
    };
  });

  /* ── helpers ──────────────────────────────────────────────── */

  function injectThumbnailBar(pswpEl, pswp, imgs) {
    // Remove any leftover bar from a previous open
    const old = pswpEl.querySelector('.pdp-pswp-thumbnails');
    if (old) old.remove();

    const bar = document.createElement('div');
    bar.className = 'pdp-pswp-thumbnails';

    imgs.forEach((img, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pdp-pswp-thumb' + (i === pswp.currIndex ? ' active' : '');
      btn.setAttribute('aria-label', `View image ${i + 1}`);

      const thumbImg = document.createElement('img');
      const baseSrc = (img.currentSrc || img.src).split('?')[0];
      thumbImg.src = `${baseSrc}?width=80&crop=center`;
      thumbImg.alt = '';
      thumbImg.loading = 'lazy';

      btn.appendChild(thumbImg);
      bar.appendChild(btn);

      btn.addEventListener('click', () => pswp.goTo(i));
    });

    pswpEl.appendChild(bar);

    // Sync active thumb on slide change
    pswp.on('change', () => syncActive(bar, pswp.currIndex));

    // Scroll first active thumb into view
    syncActive(bar, pswp.currIndex, true);
  }

  function syncActive(bar, activeIndex, instant) {
    bar.querySelectorAll('.pdp-pswp-thumb').forEach((btn, i) => {
      btn.classList.toggle('active', i === activeIndex);
    });
    const active = bar.querySelector('.pdp-pswp-thumb.active');
    if (active) {
      active.scrollIntoView({
        block: 'nearest',
        inline: 'center',
        behavior: instant ? 'instant' : 'smooth',
      });
    }
  }
})();
